import { render } from "./Tal_chanDetail.vue?vue&type=template&id=2e82b461&scoped=true"
import script from "./Tal_chanDetail.vue?vue&type=script&lang=js"
export * from "./Tal_chanDetail.vue?vue&type=script&lang=js"

import "./Tal_chanDetail.vue?vue&type=style&index=0&id=2e82b461&scoped=true&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e82b461"]])

export default __exports__